import React from 'react';
import { DropzoneRootProps } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import {
  BiData,
  SubmitReplaceSourceImageOpenBiEvent,
} from '@wix/da-bi/pkg/events';
import RefreshIcon from '@wix/da-ds/pkg/Icons/16x16/Refresh';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import { getDeviationResourceType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';

interface Props {
  deviation: PapiDeviation;
  disabled?: boolean;
  getDropzoneRootProps: () => DropzoneRootProps;
}

const ReplaceImageButton: React.FC<Props> = ({
  deviation,
  disabled,
  getDropzoneRootProps,
}) => {
  const { t } = useTranslation();
  return (
    <label {...(disabled ? {} : getDropzoneRootProps())}>
      <TextButton
        variant="main"
        size="medium"
        icon={RefreshIcon}
        role="none"
        tabIndex={-1}
        disabled={disabled}
        biData={
          deviation &&
          BiData<SubmitReplaceSourceImageOpenBiEvent>({
            evid: 31,
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId,
          })
        }
      >
        {t('deviationSubmit.form.imageReplace.button.text')}
      </TextButton>
    </label>
  );
};
ReplaceImageButton.displayName = 'ReplaceImageButton';

export default ReplaceImageButton;
